import firebase from 'firebase/app';
import 'firebase/firestore';
import { Observable, of } from 'rxjs';

/**
 * 
 * @param {Object} args 
 * @param {String} args.talentId
 */
export function talent(args) {

  if(!args.talentId) {
    return of(null);
  }

  return new Observable(observer => {
		const ref = firebase.database().ref(`talents/${args.talentId}`);
		const handler = snapshot => {
			observer.next({
				talentId:snapshot.key,
				...snapshot.val()
			});
		};
		ref.on('value', handler);
		return () => ref.off('value', handler);
	});
}